import { gql } from '@apollo/client'
import React from 'react'

import { serviceOrdersClient } from '../../../../utils/apollo/api'
import { useCurrentModal } from '../../../../components/modals/ModalsContext'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const useServiceOrderState = () => React.useContext(Context)
export const useServiceOrder = () => useServiceOrderState()?.serviceOrder

const QUERY = gql`
  query ServiceOrder($id: ID) {
    serviceOrder(id: $id, filter: { includeDeleted: true }) {
      id
      yearlyId
      description
      placeId
      checklistId
      parentId
      metadata
      documents {
        id
        src
        type
      }
      fieldValues {
        id
        value
        fieldId
        field {
          id
          name
          type
          configuration
          options {
            id
            name
            reference
            ordination
          }
        }
      }

      address {
        search
        latitude
        longitude
        complement
        city
        state
        number
        address
        postcode
        neighborhood
      }
      group {
        id
        name
      }
      groups {
        id
        name
      }
      user {
        id
        name
      }
    }
  }
`

const ServiceOrdersLoader = ({ children }) => {
  const { data: id } = useCurrentModal()

  const { data, ...state } = useQuery(QUERY, {
    variables: { id },
    client: serviceOrdersClient,
    fetchPolicy: 'no-cache'
  })

  return (
    <StatePresenter {...state}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default ServiceOrdersLoader
